import cx from 'classnames'
import { Pressable, useHover } from '@react-aria/interactions'
import { ItemProps } from './Types'
import Styles from './Sidebar.module.scss'

export const Item = ({ icon, label, isActive, onPress }: ItemProps) => {
  const { hoverProps, isHovered } = useHover({})

  return (
    <Pressable onPress={onPress}>
      <div
        className={cx(Styles.sidebarItem, { [Styles.hovered]: isHovered, [Styles.active]: isActive })}
        {...hoverProps}
      >
        <img src={icon} alt="" className={Styles.icon} />
        {label}
      </div>
    </Pressable>
  )
}
